module.exports = __webpack_public_path__ + "assets/arrow-t-b-2.107537a9.svg";